import { isBrowserMainThread } from '../utils';

export function createPromiseGuard<T = any>() {
  const requests: Map<string, Promise<T>> = new Map();

  return async (
    id: string,
    {
      factory,
      persistent = true,
    }: { factory: () => Promise<T>; persistent?: boolean },
  ) => {
    if (requests.has(id)) {
      return requests.get(id)!;
    }

    const pending = factory();

    requests.set(id, pending);

    try {
      const model = await pending;
      if (!persistent) {
        requests.delete(id);
      }
      return model;
    } catch (e) {
      if (requests.has(id)) {
        requests.delete(id);
      }
      throw e;
    }
  };
}

export function withRetry<TResponse = any>({
  times,
  task,
}: {
  task: () => Promise<TResponse>;
  times: number;
}) {
  let counter = 0;
  return new Promise<TResponse>((resolve, reject) => {
    const run = async () => {
      try {
        const response = await task();
        resolve(response);
      } catch (e) {
        counter++;
        if (counter >= times) {
          reject(e);
        } else {
          await run();
        }
      }
    };

    void run();
  });
}

export function getScriptTag(url: string) {
  if (!isBrowserMainThread()) {
    return null;
  }

  const element = document.querySelector(`script[src="${url}"]`);
  return element;
}
